import { Component, Host, Prop, h } from '@stencil/core';
import { SizeType } from '@models/generic/GenericTypes';

@Component({
  tag: 'mtx-button',
  styleUrl: 'mtx-button.css',
  shadow: true,
})
export class MtxButton {
  @Prop() variant: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'negative' | 'positive' = 'primary';
  @Prop() size: SizeType = 'small';
  @Prop() disabled = false;
  @Prop({ reflect: true }) fullWidth = false;
  @Prop() href?: string;

  render(): JSX.Element {
    const classNames = {
      button: true,
      ['button_primary']: this.variant === 'primary' && !this.disabled,
      ['button_secondary']: this.variant === 'secondary' && !this.disabled,
      ['button_tertiary']: this.variant === 'tertiary' && !this.disabled,
      ['button_quaternary']: this.variant === 'quaternary' && !this.disabled,
      ['button_negative']: this.variant === 'negative' && !this.disabled,
      ['button_positive']: this.variant === 'positive' && !this.disabled,
      ['button_small']: this.size === 'small',
      ['button_medium']: this.size === 'medium',
      ['button_large']: this.size === 'large',
      ['button_disabled']: this.disabled,
    };

    if (typeof this.href === 'string' && this.href.length > 0) {
      return (
        <Host>
          <a class={classNames} tabIndex={this.disabled ? -1 : 0} href={this.href}>
            <slot name="start-icon" />
            <slot></slot>
            <slot name="end-icon" />
          </a>
        </Host>
      );
    }

    return (
      <Host>
        <button class={classNames} tabIndex={this.disabled ? -1 : 0}>
          <slot name="start-icon" />
          <slot></slot>
          <slot name="end-icon" />
        </button>
      </Host>
    );
  }
}
